// extracted by mini-css-extract-plugin
module.exports = {"valuesModal":"valuesRewriteModal_valuesModal__3Icc8","valuesModalBody":"valuesRewriteModal_valuesModalBody__1uLaG"};